import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import { AccountListItem } from "../../../types";
import { mockAccountsList } from "../../../types/genereal";
import { columnsList } from "./columnList";
import { AccountListRow } from "./AccountListRow";
import { TableHeader } from "./TableHeader";
import { AccountListPagination } from "./AccountListPagination";
import { AccountPlanStatus } from "../../../types/enums";
import { useMemo } from "react";

interface DataTableProps {
  rows: AccountListItem[];
  totalRows?: number;
  page?: number;
  campaign_id: string;
  isSixSens: boolean;
}

export const AccountsListTable = ({
  rows,
  totalRows,
  campaign_id,
  isSixSens,
}: DataTableProps) => {
  const columns = useMemo(
    () =>
      columnsList.filter((el) => {
        return !(el.key === "buyer_journey" && !isSixSens);
      }),
    [columnsList],
  );
  return (
    <Box>
      <TableContainer>
        <Table
          sx={{
            border: "none",
            background: "white",
            boxShadow: 0,
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableHeader
              isAccountPlanRunning={rows.some(
                ({ account_plan_status }) =>
                  account_plan_status === AccountPlanStatus.in_progress,
              )}
              columns={columns}
            />
          </TableHead>
          <TableBody>
            {(rows.length > 0 ? rows : mockAccountsList).map((row) => (
              <AccountListRow
                key={row.id}
                row={row}
                columns={columns}
                total_companies={rows.length}
                campaign_id={campaign_id!}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <AccountListPagination totalRows={totalRows || 0} />
    </Box>
  );
};
